/* global Mazemap */


let poiTypeMarker;
let pixelRatio = 2;
if(window.devicePixelRatio === 1){
  poiTypeMarker = require('../assets/poitype-circlemarker-blue-30.dataurl.png');
  pixelRatio = 1;
}else{
  poiTypeMarker = require('../assets/poitype-circlemarker-blue-30@2x.dataurl.png');
}

const iconImageID = 'mm-poitypemarker-blue-30';

const defaultOptions = {
    layerProperties: {
      id: "custom-pois-layer",
      source: "custom-pois-layer",
      type: "symbol",
      minzoom: 10,
      layout: {
        "text-field": "",
        "icon-image": iconImageID,
        "icon-offset": [0, 0], // offset in x,y to get right placement. Default is [0,0] which is the center of your image
        "visibility": "visible",
        "icon-allow-overlap": true
      },
      paint: {
          "icon-opacity": {type: 'identity', property: 'opacity'},
      }
    },
    beforeLayerId: "mm-building-label",
    cluster: true,
    stopClickPropagation: false,
    clusterMaxZoom: 20, // Max zoom to cluster points on
    clusterRadius: 10 // Radius of each cluster when clustering points (defaults to 50)
  };

export default class MultiPoisMarkerLayer{

    constructor( map/*, options*/){
        if(!map){
          throw new Error('Need a map to initialize PoisLayer');
        }

        map.loadImage(poiTypeMarker, function(error, image) {
            if (error) throw error;
            map.addImage(iconImageID, image, {pixelRatio: pixelRatio});
        });

        this._map = map;

        this.options = defaultOptions;

        this._updateStyling = this._updateStyling.bind(this);
        this._onFeaturesClick = this._onFeaturesClick.bind(this);
        this.onClick = () => { }; // NOOP function that can be overwritten

        this._initStyling();

    }

    // 🍂method setPois(geojson: GeoJSON): this
    // Given a GeoJSON feature or feature collection, display it in the map
    setPois (features) {
    //  console.log(geojson);
      this._lastZLevelCalculated = null;
      this._features = features;
      this._updateStyling();
    }

    _setData (data){
      this._map.getSource(this.options.layerProperties.source).setData(data);
    }

    // 🍂method clear(): this
    // Removes any previously highlighted features from the map.
    clear () {
      this._map.getSource(this.options.layerProperties.source).setData({
        type: "FeatureCollection",
        features: []
      });
    }

    remove () {
      this._map.removeLayer(this.options.layerProperties.id);
      this._map.removeSource(this.options.layerProperties.source);
      this._map.off('zlevel', this._updateStyling );
      this._map.layerEventHandler.off('click', this.options.layerProperties.id);
    }

    addLayer ( ) {
      this._map.addLayer(this.options.layerProperties, this.options.beforeLayerId);
    }

    // Internal.
    _initStyling ( ) {

      this._map.addSource(this.options.layerProperties.source, {type: 'geojson',
        data: {
          "type": "FeatureCollection",
          "features": [],
        },
        cluster: this.options.cluster,
            clusterMaxZoom:  this.options.clusterMaxZoom,
            clusterRadius: this.options.clusterRadius
      });


      this.addLayer();

      this._map.on('zlevel', this._updateStyling );

      // Center the map on the coordinates of any clicked symbol from the 'symbols' layer.
      this._map.layerEventHandler.on('click', this.options.layerProperties.id, this._onFeaturesClick);

      this._updateStyling();

    }

    // Handle some click conditions internally, and if the right conditions are met,
    // return the clicked features for external handling...
    _onFeaturesClick (e, features){

      const map = this._map;
      const zoom = this._map.getZoom();

          if(features.length === 1 && features[0].properties.cluster){
              // Clicked only 1 feature, and it is a cluster
              return map.flyTo({center: e.lngLat, zoom: zoom + 2, duration: 1000});

          }else if (features.length === 1){
            // Clicked only 1 feature, and it is not a cluster
            // Set the map zLevel to the same as the feature
            map.setZLevel( features[0].properties.zLevel);
            return this.onClick(e, [ features[0] ]);

          }else if(features.length > 1){
            // Clicked many features, which are not clustered
        if( map.getZoom() < 21 ){
          // Not zoomed far enough in, do auto zoom
                return map.flyTo({center: e.lngLat, zoom: zoom + 2, duration: 1000});
              }else{
                  // Enough zoomed in

                  // First check if any are in the current zLevel...
                  let zLevelFeatures = features.filter( (feature) => { return feature.properties.zLevel === map.getZLevel(); });

                  if(zLevelFeatures.length){
                    return this.onClick(e, zLevelFeatures);
                  }else{
            // Nope, now let the external forces deal with the features...
                    return this.onClick(e, features);
                  }
              }
          }
    }

    _updateStyling () {
        let zLevel = this._map.zLevel;
        if(zLevel == this._lastZLevelCalculated){
          return;
        }

        let featureCollection = {type: "FeatureCollection", features: []};
        if(this._features && this._features.length){
          featureCollection.features = this._features.map( this.featureMapFunction.bind(this) );
        }
        this._setData( featureCollection );

        this._lastZLevelCalculated = zLevel;
    }

    // Calculate the new feature properties upon zLevel changes
    // Adds an opacity property for layer drawing
    featureMapFunction ( feature ) {
        let zLevel = this._map.getZLevel();
        let opacity = 1;
        let offZ = (feature.properties.zLevel !== 0) && (feature.properties.zLevel !== zLevel);
        if(offZ){
          opacity = 0.35;
        }

        let lngLat = Mazemap.Util.getPoiLngLat(feature);
        let point = {type: "Point", coordinates: [lngLat.lng, lngLat.lat]};
        let properties = feature.properties;
        properties.opacity = opacity;
        return {type: "Feature", geometry: point, properties: properties };
    }
}



// WEBPACK FOOTER //
// src/kiosk/MultiPoisMarkerLayer/index.js